import axiosInstance from '../../common/axios.service';

const config = () => {
  return axiosInstance.get('config/masterdata').then((response) => {
    return response;
  });
};

const userPasswordUpdate = (payload: {password: string}) => {
  return axiosInstance.put('employee/password', payload).then((response) => {
    return response;
  });
};

const configService = {
  config,
  userPasswordUpdate,
};

export default configService;
